<div class="col-12 col-sm-12">
<mat-tab-group mat-align-tabs="center">
  <mat-tab label="{{ 'BUYER_INFO.BUYER_INFO_TXT' | translate}}" *ngIf="stepForm">
    <div class="bg-white">
      <div class="border-bottom p-4">
        <h3 class="pt-2">{{ 'BUYER_INFO.EXTRA_BUYER_INFO' | translate}}</h3>
      </div>
       <form [formGroup]="stepForm" *ngIf="stepForm" (ngSubmit)="submit()">
       <div class="row justify-content-center px-4 ">
            <div class="row">
              <div class="col-md-12">
                <p class="d-flex mx-auto my-3">
                  {{'BUYER_INFO.ENTER_ADDITONAL_FEILDS_TEXT' | translate:{productType: 'Sellers.Dashboard.CustomPayment'| translate} }}
                </p>
                <app-form-builder-fielditem (formBuilderSave)="addingFormBuilderStep($event)">
                </app-form-builder-fielditem>
              </div>
            </div>
        </div>
        <div class="w-100 d-flex justify-content-end">
          <button type="submit" class="btn btn-primary m-3"[disabled]="stepForm.invalid && !isBuyerInfoFormValid ">
            {{ 'Sellers.Products.Save' | translate }}</button>
        </div>
      </form>
      </div>
  </mat-tab>
</mat-tab-group>
</div>
